import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {TabContent, TabPane} from "reactstrap";
import "./index.css";
import NewChatUserList from "../user-list";

class NewChatTabContent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            chatSearch: '',
        }

    }

    componentDidMount() {

    }

    UNSAFE_componentWillReceiveProps(nextProps) {

    }


    render() {
        return (
            <TabContent activeTab={this.props.activeTab} style={{marginLeft:-21}}>
                <NewChatUserList type={this.props.activeTab} userSelectedFromNewChatList={this.props.userSelectedFromNewChatList}/>
            </TabContent>
        );
    }
}

NewChatTabContent.propTypes = {
    activeTab: PropTypes.string.isRequired,
};

export default NewChatTabContent;
